import { render, staticRenderFns } from "./_base-shopping-cart.vue?vue&type=template&id=6b7123a0"
import script from "./_base-shopping-cart.vue?vue&type=script&lang=js"
export * from "./_base-shopping-cart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports